import { useQuery } from '@tanstack/react-query';
import {
  BidvBankTransferService,
  BidvBankTransferWhitelistEntity,
} from 'services/openapi';

import { BidvBankTransferServiceKeys } from './constants';

export const useGetBidvBankTransferWhitelistQuery = (
  enabled: boolean = true,
) => {
  const queryKey = [BidvBankTransferServiceKeys.GET_BANK_TRANSFER_WHITELIST];

  const {
    isLoading,
    error,
    data,
    isError,
    isFetching,
    isLoadingError,
    refetch,
  } = useQuery<BidvBankTransferWhitelistEntity, Error>({
    queryKey,
    queryFn: () =>
      BidvBankTransferService.bidvBankTransferControllerGetBidvBankTransferWhitelist(),
    retry: 0,
    refetchOnWindowFocus: false,
    enabled,
  });

  return {
    isLoading,
    isLoadingError,
    isFetching,
    error,
    data,
    isError,
    queryKey,
    refetch,
  };
};
